<script setup lang="ts">
import {DiscussReplyInfo} from "@/types";
import DiscussReplyItem from "components/course/discuss/DiscussReplyItem.vue";

defineProps<{
  replyInfo: DiscussReplyInfo | undefined,
  pagination: {
    page: number,
    pageSize: number,
    total: number
  }
}>()

const emit = defineEmits(["collapse", "onReply", "onDelete", "onPaginationChange"])

const onCollapse = () => {
  emit("collapse")
}

const onReply = (id: number) => {
  emit("onReply", id)
}

const onDelete = (id: number) => {
  emit("onDelete", id)
}

const onPaginationChange = (page: number, pageSize: number) => {
  emit("onPaginationChange", page, pageSize)
}
</script>

<template>
  <div class="bg-#f5f5f5 px-1rem py-.75rem rounded ml-48px" v-if="replyInfo">
    <discuss-reply-item
        v-for="item in replyInfo.list" :reply="item"
        @onReply="onReply"
        @on-delete="onDelete"
    ></discuss-reply-item>
    <el-pagination
        class="mt-1rem pagination-bg" :total="pagination.total"
        :page-size="pagination?.pageSize" @change="onPaginationChange"
        layout="prev, pager, next"/>
    <div class="text-.75em text-[rgba(0,0,0,0.251)] mt-1rem cursor-pointer" @click="onCollapse">收起回复</div>
  </div>
</template>

<style scoped>
.pagination-bg {
  --el-fill-color-blank: transparent;
}
</style>
